"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAll = void 0;
const tslib_1 = require("tslib");
const fetchAll = (callback_1, ...args_1) => tslib_1.__awaiter(void 0, [callback_1, ...args_1], void 0, function* (callback, limit = 5000) {
    const records = [];
    let done = false;
    let page = 1;
    do {
        const offset = records.length;
        const data = yield callback({ limit, offset, page });
        if (data.length < limit) {
            done = true;
        }
        records.push(...data);
        page++;
    } while (!done);
    return records;
});
exports.fetchAll = fetchAll;
